module.exports = __webpack_public_path__ + "img/raspa-y-gana.4000dbf7.png";